export default function ({ app }) {
  app.i18n.locale = app?.$cookiz?.get('langCode') || app.i18n.defaultLocale
}
